import {Command} from "./Command";
import {LooseGamePlay} from "../model/game-play";
import {PlayResult} from "../model/playResult";

export class SetPlayResultCommand implements Command {
  constructor(
    private gamePlay: LooseGamePlay,
    public result: PlayResult
  ) { }

  execute() {
    console.log('COMMAND SetPlayResultCommand', this.result)
    this.gamePlay.result = this.result
  }
}
